export default "__VITE_ASSET__BP2trLWj__"